import { LogOut, ShieldAlert } from 'lucide-react';
import type { ApiError } from '../lib/errors';
import { useLogout } from '../lib/logout';
import { Button } from './ui';

/**
 * Вход есть, а роли на объекте нет ни одной: сервер отвечает `403 ROLE_FORBIDDEN` во всех ролях (учётная запись без
 * назначений, демо-стенд 12.10.2026). Каркаса нет — профиль не загрузился. «Код ошибки» — requestId (FR-032): по нему
 * администратор найдёт отказ в журнале. Единственное действие — «Выйти».
 */
export function NoAccess({ error }: { error: ApiError }) {
  const logout = useLogout();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <span className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-card bg-bad-soft text-bad">
        <ShieldAlert size={20} strokeWidth={1.75} aria-hidden />
      </span>
      <h1 className="text-[15px] font-semibold">Нет доступа</h1>
      <p className="mt-1 max-w-md text-[13px] text-ink-2">
        У вашей учётной записи нет доступа к объекту. Обратитесь к администратору.
      </p>
      {error.requestId && (
        <p className="mt-2 text-[12px] text-ink-3">
          Код ошибки: <span className="font-mono text-ink-2 select-all">{error.requestId}</span>
        </p>
      )}
      <Button icon={LogOut} className="mt-5" onClick={() => void logout()}>
        Выйти
      </Button>
    </div>
  );
}
